module.exports = __webpack_public_path__ + "static/media/coloured-picind-card.a5152665.jpg";